module.exports = __webpack_public_path__ + "media/images/location_ok-993f135b.svg";